import { useParams } from "react-router-dom";
import ProductsThirdLevel from "./ProductsThirdLevel";

export default function ProductsThirdLevelWrapper() {
    const { productId } = useParams();
    return <ProductsThirdLevel key={productId} />
}